<template>
  <div class="mod-descPage">
    <div class="action-header">
      <div class="mod-breadcrumb">
        <a href="javascript:;" @click="$router.back()" class="color__666">返回</a>
        <span class="line">|</span>
        <span>导入应届生</span>
      </div>
    </div>
    <div class="mod-import">
      <div class="mi-upload">
        <div class="uploadDiv">
          <el-upload action="api/archives/excel/importStudent" :limit="1" accept=".xls,.xlsx,.xlc,.xlm,.xlt,.xlw" :name="keyName"
                     :before-upload="onBeforeUpload" :headers="headers" :data="uploadForm"
                     :show-file-list="false" class="divDrag" :onError="uploadError" :onSuccess="uploadSuccess"
                     ref="upload">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em class="color__primary">点击上传</em></div>
          </el-upload>
        </div>
        <dl class="miu-right">
          <dt>导入规范</dt>
          <dd>需先下载标准模板，然后再上传编辑好的表格；
            <el-button size="small" @click="_toExport">点击下载标准模板</el-button>
          </dd>
        </dl>
      </div>
      <div class="mi-result" v-if="uploadResult.type!=0">
        <div class="mi-title">上传结果</div>
        <div class="mir-con">
          <el-tag type="success" v-if="uploadResult.type==3">上传成功</el-tag>
          <el-tag type="danger" v-if="uploadResult.type==2">上传失败</el-tag>
          <el-tag type="warning" v-if="uploadResult.type==1">上传解析中</el-tag>
          {{uploadResult.name}}
        </div>
      </div>
    </div>
    <downExcel :dialogShow="downDialog" v-on:loading-end="downDialog=false" :progress="progress"></downExcel>
  </div>
</template>

<script type="text/ecmascript-6">
  const downExcel = () => import('@/dialog/downExcel')
  export default {
    data () {
      return {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.base.token
        },
        uploadForm: {},
        formData: {
          month: ''
        },
        keyName: 'file', // file对应key
        errData: [],
        uploadResult: {
          type: 0,
          name: ''
        },
        downDialog: false,
        progress: 0
      }
    },

    methods: {
      // 导出模版
      _toExport () {
        this.progress = 0
        this.downDialog = true
        this.$api.exportStudentTemplate(() => {
          this.progress = 100
        }, () => {
          this.downDialog = false
        })
      },
      // 上传前验证
      onBeforeUpload (file) {
        let rgx = '(.xls|.xlsx|.xlc|.xlm|.xlt|.xlw)'
        let re = new RegExp(rgx, 'i')
        let isFormat = re.test(file.name)
        let isSize = file.size / 1024 / 1024 < 1
        if (!isFormat) {
          this.$message.error('文件格式有误,请选择xls,xlsx,xlc,xlm,xlt,xlw格式!')
          return false
        }
        if (!isSize) {
          this.$message.error('上传文件大小不能超过1M！')
          return false
        }
        this.uploadResult['type'] = 1
        this.uploadResult['name'] = file.name
      },
      // 失败
      uploadError () {
        this.uploadResult['type'] = 2
        this.$refs.upload.clearFiles()
      },
      uploadSuccess (res) {
        if (res.code !== 200) {
          this.uploadResult['type'] = 2
          this.errData = res.result || []
        } else {
          this.uploadResult['type'] = 3
          this.errData = []
        }
        this.$refs.upload.clearFiles()
      }
    },
    components: {
      downExcel
    }
  }
</script>

<style type="text/scss" lang="scss" scoped>
  .mod-descPage {
    height: 100%;
    box-sizing: border-box;
    padding-top: 55px;
    position: relative;
  }

  .mod-breadcrumb {
    position: absolute;
    left: 15px;
    top: 15px;
    height: 25px;
    line-height: 25px;
    color: #666;
    font-size: 14px;

    span {
      &.line {
        padding: 0 8px;
        color: #ddd;
      }
    }

    .color__666 {
      color: #666;
    }
  }

  .action-header {
    position: absolute;
    top: 0;
    left: 15px;
    right: 15px;
    height: 54px;
    border-bottom: 1px dashed #e6e6e6;

    .mod-breadcrumb {
      left: 0;
    }

    .action-btn {
      position: absolute;
      right: 0;
      top: 11px;
    }
  }

  .mod-import {
    width: 90%;
    max-width: 1024px;
    margin: 0 auto;
    overflow-x: hidden;
  }

  .mi-month {
    padding-top: 30px;

    .el-form {
      width: 400px;
      margin: 0 auto;
    }
  }

  .mi-upload {
    padding-top: 30px;
  }

  .uploadDiv {
    display: inline-block;
    width: 52%;
    vertical-align: middle;
  }

  .miu-right {
    width: 40%;
    margin-left: 5%;
    height: 190px;
    display: inline-block;
    vertical-align: middle;

    dt {
      font-size: 14px;
      color: #333;
      line-height: 25px;
      margin-bottom: 5px;
    }

    dd {
      line-height: 32px;
      font-size: 12px;
      color: #333;
    }
  }

  .mi-result {
    padding-top: 30px;

    .mi-title {
      padding-left: 10px;
      position: relative;
      color: #333;
      font-size: 14px;
      line-height: 30px;

      &:before {
        content: '';
        width: 3px;
        height: 12px;
        position: absolute;
        left: 0;
        top: 9px;
      }
    }
  }

  .mir-con {
    background: #fff;
    padding: 10px 15px;
    box-shadow: 0 0 3px rgba(0, 0, 0, .1);
    margin: 10px 10px 15px;
    border-radius: 3px;
    color: #666;
    height: 28px;
    line-height: 28px;

    .el-tag {
      float: right;
    }
  }

  .mir-table {
    padding: 0 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/main/importStudent.vue